import React from "react";
import {
  SEO,
  PageLayout,
  Image,
  Content,
  PaginatedGrid,
  componentIterator,
} from "@bluefin/components";
import { Grid } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import { getComponentFiles } from "../utils/utils";

export default class AboutPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
        />
        <PageLayout hero={false} subfooter={false} className={"about-page"}>
          <Image
            src={getComponentFiles({
              components: fishermanBusinessWebsitePage.components,
              componentName: "HeroElement",
              componentIdentifier: "background",
              numToSelect: 1,
            })}
            className={"page-background-image"}
            background={true}
          >
            <div />
          </Image>
          <Grid
            className={"about-content-container"}
            stackable={true}
            textAlign={"center"}
          >
            <Grid.Column width={6}>
              <Content className={"about-content"} textAlign={"left"}>
                <Content.Image
                  background={true}
                  src={getComponentFiles({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "HeroElement",
                    numToSelect: 1,
                  })}
                />
                <Content.Markup
                  width={16}
                  isMarkdown={false}
                  content={
                    <div>
                      <p>
                        787 Restaurant and Bar is a Puerto Rican cuisine
                        establishment located in El Paso, Texas. Established in
                        2019, it is proud to be owned and operated by a veteran,
                        adding a unique touch to its atmosphere and values.
                      </p>
                      <p>
                        As an authentic Puerto Rican restaurant, 787 Restaurant
                        and Bar offers a diverse menu inspired by the rich
                        culinary heritage of Puerto Rico. Guests can enjoy
                        traditional Puerto Rican dishes that showcase the
                        vibrant flavors and unique blend of Spanish, African,
                        and Taíno influences.
                      </p>
                      <p>
                        The restaurant aims to create an inviting and warm
                        atmosphere, reminiscent of the lively streets of Puerto
                        Rico. Whether you're seeking a cozy dinner with friends
                        and family or a vibrant night out, 787 Restaurant and
                        Bar offers a welcoming ambiance that celebrates the
                        island's culture.
                      </p>
                      <p>
                        Alongside the delicious food, the restaurant takes pride
                        in its attentive and friendly service, ensuring that
                        every patron has a memorable dining experience. The
                        veteran ownership adds an element of dedication,
                        discipline, and integrity to the establishment,
                        reflecting the values instilled by the military.
                      </p>
                      <p>
                        787 Restaurant and Bar in El Paso, Texas, provides a
                        unique opportunity for residents and visitors alike to
                        experience the vibrant flavors of Puerto Rico without
                        having to leave the city. It serves as a culinary
                        gateway to the island, showcasing its diverse range of
                        dishes and embodying the spirit of Puerto Rican
                        hospitality.
                      </p>
                    </div>
                  }
                />
              </Content>
            </Grid.Column>
            <Grid.Column
              className={"about-image-gallery-container"}
              width={10}
              textAlign={"left"}
            >
              <PaginatedGrid
                rows={3}
                className={"image-gallery"}
                mobile={{ columns: 2, rows: 4, stackable: false }}
                items={componentIterator({
                  iterator: getComponentFiles({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "ImageCollection",
                  }),
                  component: (
                    <Image
                      background={true}
                      style={{ paddingTop: "100%", height: "100%" }}
                    />
                  ),
                  propMap: { src: "__all__" },
                })}
              />
            </Grid.Column>
          </Grid>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(pageType: { eq: "About" }) {
      title
      description
      components {
        fastId
        componentIdentifier
        order
        files {
          file
          altText
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
      }
    }
  }
`;
